import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import Chip from 'components/common/Chip';
import IconButton from 'components/common/IconButton';
import IconCheckboxChecked from 'components/icons/IconCheckboxChecked';
import IconCheckboxSelect from 'components/icons/IconCheckboxSelect';

const styles = theme => ({
  root: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 45,
    [theme.breakpoints.down('sm')]: {
      left: 0,
    },
  },
  buttonDeselect: {
    color: theme.palette.primary[500],
  },
  iconCheckboxChecked: {
    width: 18,
    height: 18,
  },
  iconCheckboxSelect: {
    width: 18,
    height: 18,
  },
  chip: {
    minWidth: 44,
    marginLeft: 10,
    marginRight: 10,
  },
  typographyButtonLabel: {
    marginLeft: -4,
    marginRight: 16,
    textTransform: 'uppercase',
    minWidth: 115,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  typographyChipLabel: {
    textTransform: 'uppercase',
  },
  countContainer: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
});

const OrdersActionsBarSecondaryControls = ({
  count,
  totalCount,
  onSelect,
  onDeselect,
  classes,
}) => (
  <Toolbar
    className={classes.root}
    disableGutters
  >
    <IconButton
      className={classNames({
        [classes.buttonDeselect]: count === totalCount,
      })}
      {...count !== totalCount
        ? {
          onClick: onSelect,
        } : {
          onClick: onDeselect,
        }}
      tooltipContent={count !== totalCount ? 'Select all' : 'Deselect all'}
    >
      {count !== totalCount ? (
        <IconCheckboxSelect className={classes.iconCheckboxSelect} />
      ) : (
        <IconCheckboxChecked className={classes.iconCheckboxChecked} />
      )}
    </IconButton>
    <Typography
      className={classes.typographyButtonLabel}
      variant="subheading"
    >
      {count !== totalCount ? 'Select all' : 'Deselect all'}
    </Typography>
    <div className={classes.countContainer}>
      <Chip
        className={classes.chip}
        color="primary"
        borderColor="primary"
        label={count}
      />
      <Typography
        className={classes.typographyChipLabel}
        variant="subheading"
      >
        Products selected
      </Typography>
    </div>
  </Toolbar>
);

OrdersActionsBarSecondaryControls.propTypes = {
  count: PropTypes.number,
  totalCount: PropTypes.number,
  onSelect: PropTypes.func,
  onDeselect: PropTypes.func,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    buttonDeselect: PropTypes.string.isRequired,
    iconCheckboxChecked: PropTypes.string.isRequired,
    iconCheckboxSelect: PropTypes.string.isRequired,
    chip: PropTypes.string.isRequired,
    typographyButtonLabel: PropTypes.string.isRequired,
    typographyChipLabel: PropTypes.string.isRequired,
  }).isRequired,
};

OrdersActionsBarSecondaryControls.defaultProps = {
  count: 0,
  totalCount: 0,
  onSelect: () => {},
  onDeselect: () => {},
};

export default withStyles(styles)(OrdersActionsBarSecondaryControls);



// WEBPACK FOOTER //
// ./src/components/workflow/OrdersActionsBar/OrdersActionsBarSecondaryControls.js